// extracted by mini-css-extract-plugin
export default {"moving-element":"CustomHeadline_moving-element__hOEWQ","moveRightToLeft":"CustomHeadline_moveRightToLeft__e3dCl"};